export default "__VITE_ASSET__38bdd15a__"